<div class="row">
  <!-- Master data -->
  <div class="col-12 col-md-8 col-xl-9 order-last order-md-first timesheet px-4">
    <ng-container *ngTemplateOutlet="masterData"></ng-container>
  </div>
  <div class="col-12 col-md-4 col-xl-3 order-first order-md-last ps-md-2 ps-lg-5 pb-5 pb-md-0 filter">
    <!-- Filter -->
    <ts-filter filterId="filterTimeSheet"
               [filters]="filters">
    </ts-filter>
  </div>
</div>

<ng-template #masterData>
  <div class="d-flex justify-content-between align-items-start mb-2">
    <h4 i18n="@@Page.MasterData.Projects.Title">
      [i18n] Customers
    </h4>
    <button type="button" class="btn btn-primary" [routerLink]="guidService.guidEmpty" [disabled]="createNewDisabled">
      <ng-container i18n="@@Page.MasterData.Projects.New">[i18n] New project</ng-container>
    </button>
  </div>

  <ts-simple-table
    *ngIf="rows"
    [columns]="columns"
    [rows]="rows"
    [configuration]="configuration">
  </ts-simple-table>
</ng-template>

<ng-template #dataCellTemplate let-row="row" let-column="column" let-table="table">
  <span [ngClass]="{'text-secondary': row.hidden}">
    {{table.getCellValue(row, column)}}
  </span>
</ng-template>

<ng-template #actionCellTemplate let-row="row">
  <a class="text-secondary me-2"
     title="[i18n] Edit Project"
     i18n-title="@@Page.MasterData.Projects.Edit"
     [routerLink]="row.id">
    <svg class="bi action-icon" fill="currentColor">
      <use xlink:href="assets/icons.svg#pencil"/>
    </svg>
  </a>
  <ts-simple-confirm
    title="[i18n] Delete project"
    i18n-title="@@Page.MasterData.Projects.Delete"
    message="[i18n] Are you sure you want to delete this project?. This cannot be undone."
    i18n-message="@@Page.MasterData.Projects.DeleteMessage"
    actionText="[i18n] Delete Project"
    i18n-actionText="@@Page.MasterData.Projects.Delete"
    color="danger"
    [disabled]="row.isReadonly ?? false"
    (confirmed)="deleteItem(row.id)">
    <a class="text-secondary">
      <svg class="bi action-icon" fill="currentColor">
        <use xlink:href="assets/icons.svg#eraser"/>
      </svg>
    </a>
  </ts-simple-confirm>
</ng-template>

<router-outlet></router-outlet>
